import React from 'react'

export function LogoLoader() {
  return (
    <div className="splash-screen">
      <img src="/logo192.png" alt="Mondra logo"/>
    </div>
  )
}
